const append = items => (array = []) => [...array, ...items]

export default append
